<template>
<!-- Sidebar -->
  <nav id="sidebar" class="bg-dark">
    <div class="p-3 ">
      <h4 class="text-white mb-0">
        <i class="fas fa-rocket me-2"></i> [linube]
      </h4>
    </div>
    
    <ul class="nav flex-column py-3">
      <li class="nav-item">
        <a class="nav-link active" href="#">
          <i class="fas fa-tachometer-alt"></i>
          <span>Dashboard</span>
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" href="#">
          <i class="fas fa-users"></i>
          <span>Compute</span>
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" href="#">
          <i class="fas fa-chart-line"></i>
          <span>Networking</span>
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" href="#">
          <i class="fas fa-box"></i>
          <span>Products</span>
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" href="#">
          <i class="fas fa-shopping-cart"></i>
          <span>Orders</span>
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" href="#">
          <i class="fas fa-file-alt"></i>
          <span>Events</span>
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" href="#">
          <i class="fas fa-cog"></i>
          <span>Settings</span>
        </a>
      </li>
    </ul>
    
    <div class="position-absolute bottom-0 w-100 p-3 border-top border-secondary">
      <a class="nav-link text-danger" href="#">
        <i class="fas fa-sign-out-alt"></i>
        <span>Logout</span>
      </a>
    </div>
  </nav>

  <!-- Top Navbar -->
  <nav class="navbar navbar-expand-lg navbar-light bg-dark top-navbar fixed-top">
    <div class="container-fluid">
      <button class="btn btn-outline-secondary me-3" id="sidebarToggle">
        <i class="fas fa-bars"></i>
      </button>
      
      <form class="d-flex flex-grow-1 me-3" style="max-width: 500px;">
        <div class="input-group">
          <span class="input-group-text bg-white border-end-0">
            <i class="fas fa-search text-muted"></i>
          </span>
          <input class="form-control border-start-0" type="search" placeholder="Search..." aria-label="Search">
        </div>
      </form>
      
      <ul class="navbar-nav ms-auto d-flex flex-row align-items-center">
        <li class="nav-item dropdown me-3">
          <a class="nav-link position-relative" href="#" id="notificationsDropdown" data-bs-toggle="dropdown">
            <i class="fas fa-bell fa-lg text-secondary"></i>
            <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
              3
            </span>
          </a>
          <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="notificationsDropdown">
            <li><h6 class="dropdown-header">Notifications</h6></li>
            <li><a class="dropdown-item" href="#"><i class="fas fa-user-plus me-2"></i>New user registered</a></li>
            <li><a class="dropdown-item" href="#"><i class="fas fa-shopping-cart me-2"></i>New order received</a></li>
            <li><a class="dropdown-item" href="#"><i class="fas fa-exclamation-triangle me-2"></i>Server alert</a></li>
            <li><hr class="dropdown-divider"></li>
            <li><a class="dropdown-item text-center" href="#">View all</a></li>
          </ul>
        </li>
        
        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle user-dropdown d-flex align-items-center" href="#" id="userDropdown" data-bs-toggle="dropdown">
            <img src="https://ui-avatars.com/api/?name=John+Doe&background=0d6efd&color=fff" alt="User" class="rounded-circle me-2">
            <span class="d-none d-md-inline">John Doe</span>
          </a>
          <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="userDropdown">
            <li><a class="dropdown-item" href="#"><i class="fas fa-user me-2"></i>Profile</a></li>
            <li><a class="dropdown-item" href="#"><i class="fas fa-cog me-2"></i>Settings</a></li>
            <li><hr class="dropdown-divider"></li>
            <li><a class="dropdown-item text-danger" href="#"><i class="fas fa-sign-out-alt me-2"></i>Logout</a></li>
          </ul>
        </li>
      </ul>
    </div>
  </nav>

  <!-- Main Content -->
  <main id="main-content" style="margin-top: 56px;">
    <div class="container-fluid p-4">
      
      <!-- Page Header -->
      <div class="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h2 class="mb-1">Dashboard</h2>
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb mb-0">
              <li class="breadcrumb-item"><a href="#">Home</a></li>
              <li class="breadcrumb-item active" aria-current="page">Dashboard</li>
            </ol>
          </nav>
        </div>
        <button class="btn btn-primary">
          <i class="fas fa-plus me-2"></i>New Item
        </button>
      </div>

      <!-- Stats Cards -->
      <div class="row g-4 mb-4">
        <div class="col-xl-3 col-md-6">
          <div class="card stat-card border-0 shadow-sm">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <p class="text-muted mb-1">Total Users</p>
                  <h3 class="mb-0">2,543</h3>
                  <small class="text-success"><i class="fas fa-arrow-up"></i> 12% from last month</small>
                </div>
                <div class="bg-primary bg-opacity-10 p-3 rounded">
                  <i class="fas fa-users fa-2x text-primary"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div class="col-xl-3 col-md-6">
          <div class="card stat-card border-0 shadow-sm">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <p class="text-muted mb-1">Revenue</p>
                  <h3 class="mb-0">$45,678</h3>
                  <small class="text-success"><i class="fas fa-arrow-up"></i> 8% from last month</small>
                </div>
                <div class="bg-success bg-opacity-10 p-3 rounded">
                  <i class="fas fa-dollar-sign fa-2x text-success"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div class="col-xl-3 col-md-6">
          <div class="card stat-card border-0 shadow-sm">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <p class="text-muted mb-1">Orders</p>
                  <h3 class="mb-0">1,234</h3>
                  <small class="text-danger"><i class="fas fa-arrow-down"></i> 3% from last month</small>
                </div>
                <div class="bg-warning bg-opacity-10 p-3 rounded">
                  <i class="fas fa-shopping-cart fa-2x text-warning"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div class="col-xl-3 col-md-6">
          <div class="card stat-card border-0 shadow-sm">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <p class="text-muted mb-1">Growth</p>
                  <h3 class="mb-0">23.5%</h3>
                  <small class="text-success"><i class="fas fa-arrow-up"></i> 5% from last month</small>
                </div>
                <div class="bg-info bg-opacity-10 p-3 rounded">
                  <i class="fas fa-chart-line fa-2x text-info"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Content Row -->
      <div class="row g-4">
        <!-- Recent Orders -->
        <div class="col-lg-8">
          <div class="card border-0 shadow-sm">
            <div class="card-header bg-white py-3">
              <h5 class="mb-0">Recent Orders</h5>
            </div>
            <div class="card-body">
              <div class="table-responsive">
                <table class="table table-hover">
                  <thead>
                    <tr>
                      <th>Order ID</th>
                      <th>Customer</th>
                      <th>Product</th>
                      <th>Amount</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>#ORD-001</td>
                      <td>Alice Johnson</td>
                      <td>Premium Plan</td>
                      <td>$299.00</td>
                      <td><span class="badge bg-success">Completed</span></td>
                      <td>
                        <button class="btn btn-sm btn-outline-primary"><i class="fas fa-eye"></i></button>
                      </td>
                    </tr>
                    <tr>
                      <td>#ORD-002</td>
                      <td>Bob Smith</td>
                      <td>Basic Plan</td>
                      <td>$99.00</td>
                      <td><span class="badge bg-warning">Pending</span></td>
                      <td>
                        <button class="btn btn-sm btn-outline-primary"><i class="fas fa-eye"></i></button>
                      </td>
                    </tr>
                    <tr>
                      <td>#ORD-003</td>
                      <td>Carol White</td>
                      <td>Enterprise Plan</td>
                      <td>$599.00</td>
                      <td><span class="badge bg-info">Processing</span></td>
                      <td>
                        <button class="btn btn-sm btn-outline-primary"><i class="fas fa-eye"></i></button>
                      </td>
                    </tr>
                    <tr>
                      <td>#ORD-004</td>
                      <td>David Brown</td>
                      <td>Premium Plan</td>
                      <td>$299.00</td>
                      <td><span class="badge bg-danger">Cancelled</span></td>
                      <td>
                        <button class="btn btn-sm btn-outline-primary"><i class="fas fa-eye"></i></button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <!-- Activity Feed -->
        <div class="col-lg-4">
          <div class="card border-0 shadow-sm">
            <div class="card-header bg-white py-3">
              <h5 class="mb-0">Recent Activity</h5>
            </div>
            <div class="card-body">
              <div class="d-flex mb-3">
                <div class="flex-shrink-0">
                  <div class="bg-primary bg-opacity-10 p-2 rounded">
                    <i class="fas fa-user-plus text-primary"></i>
                  </div>
                </div>
                <div class="flex-grow-1 ms-3">
                  <p class="mb-0 fw-semibold">New user registered</p>
                  <small class="text-muted">2 minutes ago</small>
                </div>
              </div>
              
              <div class="d-flex mb-3">
                <div class="flex-shrink-0">
                  <div class="bg-success bg-opacity-10 p-2 rounded">
                    <i class="fas fa-check-circle text-success"></i>
                  </div>
                </div>
                <div class="flex-grow-1 ms-3">
                  <p class="mb-0 fw-semibold">Order completed</p>
                  <small class="text-muted">15 minutes ago</small>
                </div>
              </div>
              
              <div class="d-flex mb-3">
                <div class="flex-shrink-0">
                  <div class="bg-warning bg-opacity-10 p-2 rounded">
                    <i class="fas fa-exclamation-triangle text-warning"></i>
                  </div>
                </div>
                <div class="flex-grow-1 ms-3">
                  <p class="mb-0 fw-semibold">Server alert</p>
                  <small class="text-muted">1 hour ago</small>
                </div>
              </div>
              
              <div class="d-flex mb-3">
                <div class="flex-shrink-0">
                  <div class="bg-info bg-opacity-10 p-2 rounded">
                    <i class="fas fa-comment text-info"></i>
                  </div>
                </div>
                <div class="flex-grow-1 ms-3">
                  <p class="mb-0 fw-semibold">New comment</p>
                  <small class="text-muted">2 hours ago</small>
                </div>
              </div>
              
              <a href="#" class="btn btn-sm btn-outline-primary w-100">View All Activity</a>
            </div>
          </div>
        </div>
      </div>

    </div>
  </main>
</template>

<script>
import { mixinDevice } from '@/utils/mixin.js'

import Breadcrumb from '@/components/widgets/Breadcrumb'

export default {
  name: 'Onboarding',
  components: {
    Breadcrumb,
    
  },
  mixins: [mixinDevice],
  data() {
    return {
      resource:{},
    }
  },
  mounted() {
    
  },
  methods: {
    
  }
}
</script>

  <style>
    body {
      overflow-x: hidden;
    }
    
    /* Sidebar styles */
    #sidebar {
      min-height: 100vh;
      transition: margin-left 0.3s ease-in-out;
      position: fixed;
      top: 0;
      left: 0;
      z-index: 1000;
      width: 250px;
    }
    
    #sidebar.collapsed {
      margin-left: -250px;
    }
    
    #sidebar .nav-link {
      color: rgba(255, 255, 255, 0.8);
      padding: 0.75rem 1rem;
      border-left: 3px solid transparent;
      transition: all 0.2s;
    }
    
    #sidebar .nav-link:hover {
      color: #fff;
      background-color: rgba(255, 255, 255, 0.1);
      border-left-color: #0d6efd;
    }
    
    #sidebar .nav-link.active {
      color: #fff;
      background-color: rgba(255, 255, 255, 0.1);
      border-left-color: #0d6efd;
    }
    
    #sidebar .nav-link i {
      width: 20px;
      margin-right: 10px;
    }
    
    /* Main content area */
    #main-content {
      margin-left: 250px;
      transition: margin-left 0.3s ease-in-out;
      min-height: 100vh;
    }
    
    #main-content.expanded {
      margin-left: 0;
    }
    
    /* Header/Navbar */
    .top-navbar {
      margin-left: 250px;
      transition: margin-left 0.3s ease-in-out;
      box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    }
    
    .top-navbar.expanded {
      margin-left: 0;
    }
    
    /* User dropdown in header */
    .user-dropdown img {
      width: 32px;
      height: 32px;
      object-fit: cover;
    }
    
    /* Content cards */
    .stat-card {
      transition: transform 0.2s;
    }
    
    .stat-card:hover {
      transform: translateY(-5px);
    }
    
    /* Responsive */
    @media (max-width: 768px) {
      #sidebar {
        margin-left: -250px;
      }
      
      #sidebar.show {
        margin-left: 0;
      }
      
      #main-content,
      .top-navbar {
        margin-left: 0;
      }
    }
  </style>